import { Route } from 'react-router'
import { observer } from 'mobx-react-lite'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { CustomFieldsAccessLayout } from 'pages/settings/pages/customFields/layout/CustomFieldsAccessLayout'
import { CustomFieldsPage } from 'pages/settings/pages/customFields/ui/CustomFieldsPage'

export const CustomFieldsRouter = observer(() => {
  return (
    <RoutesWithNotFound>
      <Route element={<CustomFieldsAccessLayout />}>
        <Route index element={<CustomFieldsPage />} />
      </Route>
    </RoutesWithNotFound>
  )
})
